import { render, staticRenderFns } from "./taskcenter.vue?vue&type=template&id=1d3ad50a&scoped=true"
import script from "./taskcenter.vue?vue&type=script&lang=js"
export * from "./taskcenter.vue?vue&type=script&lang=js"
import style0 from "./taskcenter.vue?vue&type=style&index=0&id=1d3ad50a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ad50a",
  null
  
)

export default component.exports